import React, { useEffect, useState } from "react";
import { IoIosClose } from "react-icons/io";
import { FaWhatsapp, FaRegEnvelope, FaRegCopy, FaShareAlt } from "react-icons/fa";

import "../styles/shareModal.css";

function ShareModal({ isOpen, onClose, url, title }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setCopied(false);
      return;
    }

    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const shareText = title ? `${title} - ${url}` : url;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch (error) {
      console.error("Erro ao copiar o link:", error);
    }
  };

  const handleNativeShare = () => {
    navigator.share({ title, url }).catch(() => {});
  };

  return (
    <div className="share-modal__overlay" onClick={onClose}>
      <div
        className="share-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="share-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="share-modal__handle" />

        <div className="share-modal__header">
          <h2 id="share-modal-title" className="share-modal__title">
            Compartilhar imóvel
          </h2>
          <button
            type="button"
            className="share-modal__close"
            onClick={onClose}
            aria-label="Fechar"
          >
            <IoIosClose />
          </button>
        </div>

        <div className="share-modal__link-row">
          <input
            type="text"
            className="share-modal__link-input"
            value={url}
            readOnly
            onFocus={(e) => e.target.select()}
          />
          <button type="button" className="share-modal__copy" onClick={handleCopy}>
            <FaRegCopy aria-hidden="true" />
            <span>Copiar</span>
          </button>
        </div>

        {copied && <p className="share-modal__feedback">Link copiado!</p>}

        <div className="share-modal__options">
          <a
            className="share-modal__option"
            href={`https://wa.me/?text=${encodeURIComponent(shareText)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="share-modal__option-icon share-modal__option-icon--whatsapp">
              <FaWhatsapp aria-hidden="true" />
            </span>
            <span>WhatsApp</span>
          </a>

          <a
            className="share-modal__option"
            href={`mailto:?subject=${encodeURIComponent(
              title || "Imóvel"
            )}&body=${encodeURIComponent(shareText)}`}
          >
            <span className="share-modal__option-icon share-modal__option-icon--email">
              <FaRegEnvelope aria-hidden="true" />
            </span>
            <span>E-mail</span>
          </a>

          {typeof navigator !== "undefined" && navigator.share && (
            <button
              type="button"
              className="share-modal__option"
              onClick={handleNativeShare}
            >
              <span className="share-modal__option-icon share-modal__option-icon--native">
                <FaShareAlt aria-hidden="true" />
              </span>
              <span>Mais opções</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ShareModal;
